import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectUploadButton extends PageObject {
  buttonWidth: number;
  buttonHeight: number;
  text: string;
  font: string;
  fontSize: number;
  icon: string;
  buttonType: string;
  enable: boolean;
  uploadType: string;
  fileSrc: string;

  constructor(obj: PageObjectUploadButton = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.UploadButton;

    if (obj == null) {
      this.buttonWidth = 200;
      this.buttonHeight = 44;
      this.text = "Select File";
      this.font = "arial";
      this.fontSize = 16;
      this.icon = "";
      this.buttonType = "btn-default";
      this.enable = true;
      this.uploadType = "image";
      this.fileSrc = "";
    } else {
      this.buttonWidth = obj.buttonWidth;
      this.buttonHeight = obj.buttonHeight;
      this.text = obj.text;
      this.font = obj.font;
      this.fontSize = obj.fontSize;
      this.icon = obj.icon;
      this.buttonType = obj.buttonType;
      this.enable = obj.enable;
      this.uploadType = obj.uploadType;
      this.fileSrc = obj.fileSrc;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Button Width", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Button Height", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Text", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Font", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Font Size", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Icon", OBJECTPROPERTYTYPE.Text));
    let buttonType = new ObjectProperty("Button Type", OBJECTPROPERTYTYPE.List);
    buttonType.addOption("btn-default", "Default");
    buttonType.addOption("btn-primary", "Primary");
    buttonType.addOption("btn-success", "Success");
    buttonType.addOption("btn-info", "Info");
    buttonType.addOption("btn-warning", "Warning");
    buttonType.addOption("btn-danger", "Danger");
    buttonType.addOption("btn-link", "Link");
    list.push(buttonType);
    list.push(new ObjectProperty("Enable", OBJECTPROPERTYTYPE.Boolean));
    let uploadType = new ObjectProperty("Upload Type", OBJECTPROPERTYTYPE.List);
    uploadType.addOption("image", "Image");
    uploadType.addOption("video", "Video");
    uploadType.addOption("pdf", "PDF");
    list.push(uploadType);

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Button Width") {
      return this.buttonWidth;
    } else if (name == "Button Height") {
      return this.buttonHeight;
    } else if (name == "Text") {
      return this.text;
    } else if (name == "Font") {
      return this.font;
    } else if (name == "Font Size") {
      return this.fontSize;
    } else if (name == "Icon") {
      return this.icon;
    } else if (name == "Button Type") {
      return this.buttonType;
    } else if (name == "Enable") {
      return this.enable;
    } else if (name == "Upload Type") {
      return this.uploadType;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Button Width") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.buttonWidth = newValue;
      }
    } else if (name == "Button Height") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.buttonHeight = newValue;
      }
    } else if (name == "Text") {
      this.text = value;
    } else if (name == "Font") {
      this.font = value;
    } else if (name == "Font Size") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.fontSize = newValue;
      }
    } else if (name == "Icon") {
      this.icon = value;
    } else if (name == "Button Type") {
      this.buttonType = value;
    } else if (name == "Enable") {
      this.enable = value == "true";
    } else if (name == "Upload Type") {
      this.uploadType = value;
    }
  }
}
